import { useRef } from 'react';
import { debounce } from 'lodash';

export function useDebounceCallback(fn: (...args:any[]) => any, delay: number = 750) {
    const debouncedCallback = useRef(debounce(fn, delay)).current;
    return debouncedCallback;
}